import { Stack, styled } from '@mui/material';
import { blue, grey } from 'common/theme/palette/colors';

export const CalendarWrapper = styled(Stack)(({ theme: { spacing, typography } }) => ({
  '--fc-border-color': grey[300],
  '--fc-event-bg-color': blue[500],
  '--fc-event-border-color': blue[500],

  border: 'none',

  '& .fc-theme-standard .fc-scrollgrid': {
    border: 'none',
  },
  '& thead th': {
    borderLeft: 'none',
    borderRight: 'none',
  },
  '& thead th:first-of-type': {
    borderBottom: 'none',
  },
  '& tbody tr td:first-of-type': {
    borderLeft: 'none',
    borderTop: 'none',
  },
  '& td[role="presentation"]': {
    borderBottom: 'none',
  },
  '& .fc-timegrid-col .fc-timegrid-col-frame': {
    borderBottom: '1px solid var(--fc-border-color)',
  },
  '& .fc-timegrid-col:first-of-type .fc-timegrid-col-frame': {
    borderBottom: 'none',
  },
  '& .fc-timegrid-slot-label': {
    paddingRight: spacing(2),
  },
  '& .fc-timegrid-slot-label-cushion': {
    ...typography['natter-text-xs'],
    color: grey[600],
    fontWeight: 500,
  },
  '& .fc-timegrid-event': {
    borderRadius: 4,
    overflow: 'hidden',
  },
}));
